<main class="drawer-content">
    <section>
        <mat-nav-list>
            <mat-accordion>
                @for (tab of filteredTabs(); track tab) {
                    <mat-list-item
                        (click)="navItemClick.emit()"
                        [routerLinkActiveOptions]="{ exact: tab.route === '' }"
                        [routerLink]="getRoute(tab.route)"
                        class="mb-[8px]"
                        routerLinkActive="active">
                        <div class="flex items-center gap-[8px]">
                            <mat-icon [svgIcon]="tab.activeIcon"></mat-icon>
                            <p class="text-[14px]">{{ tab.label }}</p>

                            @if (tab.route === "" ? activeRoute === "/" : activeRoute.includes(getRoute(tab.route))) {
                                <mat-icon class="ml-auto text-white">chevron_right</mat-icon>
                            }
                        </div>
                    </mat-list-item>
                }
            </mat-accordion>
        </mat-nav-list>
    </section>
</main>
